import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class AssignmentTemplateApi extends BaseApi {
    constructor(client, basePath = '/assignment-templates') {
        super(client, basePath);
    }

    async getUnitHeadOptions() {
        try {
            const response = await this.client.get(`${this.basePath}/unit-head-options`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    /** Dry-run expanded route for a requester / unit context. */
    async preview(data) {
        try {
            const response = await this.client.post(`${this.basePath}/preview`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
